<script>
  import compraServico from '../servico';
  import { alert } from 'vue-strap';
  import ListaPedidos from './compartilhado/PedidoRelatorioCompra.vue';
  import ModalLiberarCompra from '~componentes/ModalLiberarCompra.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  
  export default {
    components: {alert , ListaPedidos, ModalLiberarCompra, ModalArquivosSolicitacao, ModalMensagem},
    data() {
      return {
        carregando: true,
        compra: {},
        permissaoLiberacao: false,
        modalLiberarCompra: false,
        modalArquivos: false,
        modalMensagem: false,
        solicitacaoSelecionada: null,
        compraSelecionada: null,
        salvandoLiberacao: false,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar() {
        this.carregando = true;
        
        return compraServico
          .obterPorId(this.$route.params.id)
          .then(compra => {
            this.carregando = false;

            this.compra = compra;
            this.permissaoLiberarCompra();
          });
      },
      liberar() {
        $('#liberar').button('loading');
        this.modalLiberarCompra = false;
        
        return compraServico
          .liberar(this.$route.params.id)
          .then(() => {
            $('#liberar').button('reset');
            
            toastr.success(`Compra liberada com sucesso.`);
            $('body').removeClass('modal-open');

            this.$router.push({ name: 'compra.compra' });
          })
          .catch(erro => {
            $('#liberar').button('reset');
            
            this.$mensagemErro(erro, 'Erro ao tentar liberar a compra, ou usuário não possui permissão.');
          });
      },
      retornaDataFormatada(data) {
        if (data == null) {
          return '---';
        }

        return this.$options.filters.formatarData(data) + ' às ' +
          this.$options.filters.formatarHora(data);
      },
      retornaLiberadoNaoLiberado(liberado, tipo) {
        if (liberado == null)
          if (tipo == 't')
            return 'Não liberado';       
          else
            return 'fa fa-check-circle naoLiberado';

        if (liberado > 0)
          if (tipo == 't')
            return 'Liberado';       
          else
            return 'fa fa-check-circle liberado'
        else
          if (tipo == 't')
            return 'Não liberado';       
          else
            return 'fa fa-check-circle naoLiberado';   
      },
      permissaoLiberarCompra() {
        compraServico
        .permissaoLiberarCompra(this.$route.params.id)
        .then(permissao => {

          this.permissaoLiberacao = permissao;
        })
        .catch(erro => {
          this.permissaoLiberacao = false;
        });
      },
      mostrarModalLiberarCompra(compra) {
        this.compraSelecionada = compra;
        this.modalLiberarCompra = true;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalLiberarCompraFechado() {
        this.animated = false;
        this.modalLiberarCompra = false;
        this.compraSelecionada = null;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },      
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
      usuario1() {
        if (!this.compra.compraLiberacao)
          return '---';

        return (this.compra.compraLiberacao.usuario1) ? this.compra.compraLiberacao.usuario1.nome : '---';
      },
      usuario2() {
        if (!this.compra.compraLiberacao)
          return '---';

        return (this.compra.compraLiberacao.usuario2) ? this.compra.compraLiberacao.usuario2.nome : '---';
      },
      usuario3() {
        if (!this.compra.compraLiberacao)
          return '---';

        return (this.compra.compraLiberacao.usuario3) ? this.compra.compraLiberacao.usuario3.nome : '---';
      },
      usuarioCompra() {
        if (!this.compra.compraLiberacao)
          return '---';

        return (this.compra.compraLiberacao.usuarioCompra) ? this.compra.compraLiberacao.usuarioCompra.nome : '---';
      }
    },
    mounted() {
      this.$root.botaoAcaoMostrar = false;
      this.$root.tituloDaPagina = 'Liberação de compras - Relatório';
      this.carregar(); 
      this.modalLiberarCompra = false;
    },
  }
</script>

<style scoped>
  .liberado {
    font-size: 1.35em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .naoLiberado {
    font-size: 1.35em;
    color: #f5f5f5;
    margin-right: 3px;
  }
</style>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <modal-liberar-compra :mostrar="modalLiberarCompra"
                            :id="compraSelecionada ? compraSelecionada.idCompra : ''"
                            :salvando="salvandoLiberacao"
                            @fechado="modalLiberarCompraFechado"
                            @liberar="liberar">
    </modal-liberar-compra>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                                tipo="compra"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                    tipo="SolCompra"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando">

              <template v-for="pedido in compra.pedidos">
                <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
                  <div class="btn-group" role="group">
                    <button type="button" :class="['btn btn-primary', {'active': true}]">
                      <i class="fa fa-truck"></i> Pedido
                    </button>
                  </div>
                </div>

                <lista-pedidos :pedido="pedido"
                               :solicitacaoCompra="compra.solicitacaoCompra">
                </lista-pedidos>

              </template>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-1">
                  <dt>Liberação</dt>
                </dl>
                <dl class="col-xs-1">
                  <dt>LI</dt>
                </dl>
                <dl class="col-xs-2">
                  <dt>Data liberação</dt>
                </dl>
                <dl class="col-xs-4">
                  <dt>Usuário liberação</dt>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 1</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(compra.compraLiberacao ? compra.compraLiberacao.idUsuarioNivel1 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(compra.compraLiberacao ? compra.compraLiberacao.idUsuarioNivel1 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (compra.compraLiberacao)  !== null ?  this.retornaDataFormatada(compra.compraLiberacao.dataHoraLiberacaoNivel1) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{  this.usuario1()  }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 2</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(compra.compraLiberacao ? compra.compraLiberacao.idUsuarioNivel2 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(compra.compraLiberacao ? compra.compraLiberacao.idUsuarioNivel2 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (compra.compraLiberacao)  !== null ?  this.retornaDataFormatada(compra.compraLiberacao.dataHoraLiberacaoNivel2) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuario2()   }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 3</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(compra.compraLiberacao ? compra.compraLiberacao.idUsuarioNivel3 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(compra.compraLiberacao ? compra.compraLiberacao.idUsuarioNivel3 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (compra.compraLiberacao)  !== null ?  this.retornaDataFormatada(compra.compraLiberacao.dataHoraLiberacaoNivel3) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuario3()  }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Compra</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(compra.compraLiberacao ? compra.compraLiberacao.idUsuarioCompraLiberada : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(compra.compraLiberacao ? compra.compraLiberacao.idUsuarioCompraLiberada : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (compra.compraLiberacao)  !== null ?  this.retornaDataFormatada(compra.compraLiberacao.dataCompraLiberada) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuarioCompra() }}</dd>
                </dl>
              </div>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <div class="text-center">

                  <button type="button"
                          class="btn btn-success"
                          v-tooltip="'Enviar mensagem'"
                          @click="mostrarModalMensagem(compra.solicitacaoCompra)"
                          v-if="!configuracao.naoUtilizarMensageria">
                    <i class="fa fa-comment"></i> Mensagens
                  </button>

                  <button type="button"
                          class="btn btn-info"
                          v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                          @click="mostrarModalArquivos(compra.solicitacaoCompra)"
                          v-if="configuracao.usarArquivosSolicitacaoCompras">
                    <i class="fa fa-archive"></i> Arquivos
                  </button>

                  <button v-if="permissaoLiberacao"
                          class="btn btn-primary"
                          v-tooltip="'Liberar compra'"
                          @click="mostrarModalLiberarCompra(compra)">
                    <i class="fa fa-check"></i> Liberar compra
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/compra/componentes/Relatorio.vue